import { Supplier } from '../../models/supplier';
import { createReducer, on } from '@ngrx/store';
import {
  getSuppliersSuccess,
  cleanUpSuppliers,
  createSupplierSuccess,
  updateSupplierSuccess,
} from './suppliers.actions';

export const SuppliersFeatureKey = 'suppliers';

export type SuppliersState = Supplier[]

const initialState: SuppliersState = [];

export const suppliersReducer = createReducer(
  initialState,
  on(getSuppliersSuccess, (state, { suppliers }) => suppliers),
  on(createSupplierSuccess, (state, { supplier }) => {
    return [...state, supplier];
  }),
  on(updateSupplierSuccess, (state, { supplier }) => {
    return state.map((s) => s.id !== supplier.id ? s : supplier);
  }),
  on(getSuppliersSuccess, (state, { suppliers }) => suppliers),
  on(cleanUpSuppliers, (state) => [])
);
